import GalleryList from "~/components/GalleryList";
import { getLink, trans } from "~/providers/lang";
import { ROUTES } from "~/const";
import { useSeo } from "~/hooks/useSeo";
import { mainStore } from "~/stores/main";

export default function GallerySchoolWeddingPage() {
	useSeo({
		title: trans("skelet.title.schoolWedding"),
		canonical: "galerie-poloneza",
	});

	const pageData = mainStore(state => state.data.pageData);
	const source = pageData.photos.schoolWedding;

	return <GalleryList baseUrl={getLink(ROUTES.gallerySchoolWedding)} title={trans("template.schoolWedding")} source={source} />;
}
